// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2_0UG","inner":"Footer_inner__28RfD"};